import type { FunctionComponent } from "react";
import { graphql, useFragment } from "react-relay";

import type { subheaderMorningStudioSubheaderContent$key } from "~/queries/__generated__/subheaderMorningStudioSubheaderContent.graphql";

import {
  ContentContainer,
  StyledArticleShareWidget,
  StyledArticleSponsor,
  StyledMorningStudioLogo,
  SubheaderContainer,
} from "./styles";

type Props = {
  className?: string;
  reference: subheaderMorningStudioSubheaderContent$key;
};

export const MorningStudioSubheader: FunctionComponent<Props> = ({
  className,
  reference: reference_,
}) => {
  const content = useFragment(
    graphql`
      fragment subheaderMorningStudioSubheaderContent on Content {
        ...articleShareWidgetArticle
        ...articleSponsorContent
      }
    `,
    reference_,
  );

  return (
    <SubheaderContainer className={className}>
      <ContentContainer>
        <StyledArticleSponsor
          reference={content}
          sponsorTagStyle={{
            color: "#FFFFFF",
            layoutDirection: "horizontal",
            typeFontSize: "14px",
            typeLineHeight: "16px",
          }}
        />
        <StyledMorningStudioLogo />
        <StyledArticleShareWidget reference={content} variant={"morningStudioSubheader"} />
      </ContentContainer>
    </SubheaderContainer>
  );
};
